import { EstablishmentsHeader } from "./components/EstablishmentsHeader";
import { EstablishmentsContent } from "./components/EstablishmentsContent";
import { JSX } from "react";

export const EstablishmentsPageContainer = (): JSX.Element => {
    return (
        <section className={"p-establishments"}>
            <EstablishmentsHeader />
            <EstablishmentsContent />
        </section>
    );
};
